import { useLocation, useNavigate } from 'react-router-dom'

import { useEffect, useState } from 'react'
import { useLogOut } from '../../hooks/query/useLogOut'
import { isMobile } from 'react-device-detect'
import useGetMe from '../../hooks/query/useGetMe'
import useTranslation from '../../hooks/useTranslation'
import LanguageSelector from '../common/LanguageSelector'

import {
  GNB,
  getLocalStorage,
  onLogOut,
  saveLocalStorage,
  UserType,
  PC_SELECT_BTN_LIST,
  MOBILE_SELECT_BTN_LIST,
  MOBILE_SELECT_BTN_LIST_NO_USER,
} from '../../utils/common'
import { FreeButton } from '../atom/FreeButton'

import classNames from 'classnames'

import useUserStore from '../../store/useUserStore'
import usePrevStore from '../../store/usePrevStore'
import usePlanStore from '../../store/usePlanStore'
import useGetMePlan from '../../hooks/query/useGetMePlan'
import { createLogger } from 'utils/logger'
const logger = createLogger('Header')
const Header = () => {
  const { t } = useTranslation()
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')

  const navigate = useNavigate()
  const sample = getLocalStorage('guide_sample')
  if (!sample) {
    saveLocalStorage('guide_sample', '1')
  }
  const location = useLocation()
  if (token) {
    localStorage.setItem('token', token)
    const searchParams = new URLSearchParams(location.search)
    searchParams.delete('token')
    const baseUrl = location.pathname
    const modifiedUrl = `${baseUrl}${
      searchParams.toString() ? '?' + searchParams.toString() : ''
    }`

    navigate(modifiedUrl)
  }

  const { pathname } = useLocation()
  const [logOutStatus, setLogOutStatus] = useState<boolean>(false)
  const [hambugerStatus, setHambugerStatus] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isPriceGuideOpen, setPiceGuideOpen] = useState(false)

  const { mutate: logoutMutate } = useLogOut()
  const set = useUserStore((state: any) => state.set)
  const prevSet = usePrevStore((state: any) => state.set)
  const setRefetch = useUserStore((state: any) => state.setRefetch)
  const setPlanRefetch = usePlanStore((state: any) => state.setRefetch)
  const setPlan = usePlanStore((state: any) => state.set)
  const { data: userData, refetch } = useGetMe()
  const { data: userPlanData, refetch: planRefetch } = useGetMePlan()

  set({ userInfo: userData })
  setPlan({ userPlanInfo: userPlanData })

  const moveToPageByPath = (path: string) => {
    setHambugerStatus(false)
    switch (path) {
      case 'sign-in':
        navigate('sign-in')
        break
      case 'sign-up':
        navigate('sign-up')
        break
      case 'video-editor':
        navigate('/video-editor')
        break
      case 'youtube-auth':
        navigate('/youtube-auth')
        break
      case 'my-payments':
        navigate('/my-payments')
        break
      case 'my-videos':
        navigate('/my-videos')
        break
      case 'price-guide':
        navigate('/price-guide')
        break
      case 'shortform-price-guide':
        navigate('/shortform-price-guide')
        break
      case 'faq':
        navigate('/QnA')
        break
      case 'short-video-editor':
        navigate('/short-video-editor')
        break
      case 'my-cash-dashboard':
        navigate('/my-cash-dashboard')
        break
      case 'event-page':
        navigate('/event-page')
        break
      case 'my-page':
        navigate('/my-page')
        break
      case 'challenge':
        navigate('/challenge')
        break
      case 'coupon-pck':
        navigate('coupon-pack')
        break
      case 'tiktok':
        navigate('/tiktok')
        break
      default:
        navigate('/')
        break
    }
  }
  const handleHambugerIconClick = () => {
    setHambugerStatus(!hambugerStatus)
  }

  const createMobileBtn = () => {
    return (
      <>
        <div
          className="flex justify-center mb-[18px] mt-[30px] "
          onClick={handleHambugerIconClick}
        >
          <button>
            <img src="assets/img/Icon_x.png" alt="x" width={24} height={24} />
          </button>
        </div>

        <div className="flex flex-col items-center px-[26px] py-[8px]">
          {!!userData?.userInfo ? (
            <>
              {' '}
              <div className="flex flex-col gap-[8px]  w-full items-center">
                {MOBILE_SELECT_BTN_LIST.map((el, inex) => {
                  if (el.path === 'my-page') {
                    return (
                      <>
                        <button
                          className="py-[16px] w-full  text-center"
                          onClick={() => {
                            moveToPageByPath('my-page')
                          }}
                        >
                          {t('header.myPage')}
                        </button>
                      </>
                    )
                  }
                  if (el.path === 'blog') {
                    return (
                      <a
                        className="py-[16px] w-full text-center"
                        href="https://blog.fastseller.shop/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t('header.navigation.blog')}
                      </a>
                    )
                  } else if (el.name === 'line') {
                    return (
                      <div className="h-[1px] w-full bg-[#D9DEE8] my-[16px] "></div>
                    )
                  } else if (el.path === 'logout') {
                    return (
                      <button className="py-[16px] w-full" onClick={onLogOut}>
                        {t('header.logout')}
                      </button>
                    )
                  } else if (el.path === 'youtube-auth' && userData) {
                    if (
                      userData.userType === UserType.프로 ||
                      userData.userType === UserType.프리미엄 ||
                      userData.userType === UserType.체험 ||
                      userData.userType === UserType['숏폼 스페셜']
                    ) {
                      return (
                        <button
                          onClick={() => {
                            moveToPageByPath('youtube-auth')
                          }}
                          className="py-[16px] w-full"
                        >
                          {t('header.navigation.autoUpload')}
                        </button>
                      )
                    } else {
                      return <></>
                    }
                  }
                  return (
                    <button
                      className=" py-[16px] w-full flex items-center  justify-center"
                      onClick={() => {
                        moveToPageByPath(el.path)
                      }}
                    >
                      {(el as any).translationKey
                        ? t((el as any).translationKey)
                        : el.name}
                      {el.event && (
                        <p className="bg-[#FF8800] text-white p-1 font-bold text-[10px] rounded-[4px] ml-1 h-[20px] flex items-center">
                          <span>{t('header.navigation.payback')}</span>
                        </p>
                      )}
                    </button>
                  )
                })}
              </div>
            </>
          ) : (
            <>
              {' '}
              <div className="flex flex-col gap-[8px]  w-full items-center">
                {MOBILE_SELECT_BTN_LIST_NO_USER.map((el, inex) => {
                  if (el.path === 'blog') {
                    return (
                      <a
                        className="py-[16px] w-full text-center"
                        href="https://blog.fastseller.shop/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t('header.navigation.blog')}
                      </a>
                    )
                  } else if (el.name === 'line') {
                    return (
                      <div className="h-[1px] w-full bg-[#D9DEE8] my-[16px] "></div>
                    )
                  } else if (el.path === 'sign-in') {
                    if (!userData?.userInfo) {
                      return (
                        <button
                          className="py-[16px] w-full"
                          onClick={() => {
                            moveToPageByPath(el.path)
                          }}
                        >
                          {el.name}
                        </button>
                      )
                    } else {
                      return <></>
                    }
                  } else if (el.path === 'sign-up') {
                    if (!userData?.userInfo) {
                      return (
                        <FreeButton
                          className=" p-[20px] h-[48px] bg-href  text-white font-bold rounded-[30px] flex justify-center items-center"
                          onClick={() => {
                            moveToPageByPath('sign-up')
                          }}
                        >
                          {t('header.signup')}
                        </FreeButton>
                      )
                    } else {
                      return <></>
                    }
                  }
                  return (
                    <button
                      className=" py-[16px] w-full flex items-center  justify-center"
                      onClick={() => {
                        moveToPageByPath(el.path)
                      }}
                    >
                      {(el as any).translationKey
                        ? t((el as any).translationKey)
                        : el.name}
                      {el.event && (
                        <p className="bg-[#FF8800] text-white p-1 font-bold text-[10px] rounded-[4px] ml-1 h-[20px] flex items-center">
                          <span>{t('header.navigation.payback')}</span>
                        </p>
                      )}
                    </button>
                  )
                })}
              </div>
            </>
          )}
        </div>
      </>
    )
    // 공통 요소
  }

  const createSelectBtn = () => {
    //우상단 선택 요소들

    return (
      <>
        <div
          className="flex flex-col bg-[#FFFFFF] w-[169px] h-auto justify-center items-center absolute right-[30px] border rounded-[10px] top-20 z-50 text-[14px] py-5"
          onMouseLeave={() => setLogOutStatus(false)}
        >
          {PC_SELECT_BTN_LIST.map((el, inex) => {
            if (el.path === 'logout') {
              return (
                <div className="hover:bg-[#F6F6F6] w-full h-[46px]  flex items-center justify-center">
                  <button onClick={onLogOut} className="w-full h-full">
                    {t('header.logout')}
                  </button>
                </div>
              )
            } else if (el.name === 'line') {
              return (
                <>
                  {' '}
                  <hr className=" h-[1px] w-[94px] border-t border-dashed border-[#D9DEE8] my-3" />
                </>
              )
            } else if (el.path === 'blog') {
              return (
                <a
                  className="py-[16px] w-full text-center"
                  href="https://blog.fastseller.shop/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('header.navigation.blog')}
                </a>
              )
            } else if (el.path === 'youtube-auth' && userData) {
              if (
                userData.userType === UserType.프로 ||
                userData.userType === UserType.프리미엄 ||
                userData.userType === UserType.체험 ||
                userData.userType === UserType['숏폼 스페셜']
              ) {
                return (
                  <div className="relative hover:bg-[#F6F6F6] w-full h-[46px] flex items-center justify-center">
                    <button
                      onClick={() => {
                        moveToPageByPath('youtube-auth')
                      }}
                      className="w-full h-full"
                    >
                      {t('header.navigation.autoUpload')}
                    </button>
                  </div>
                )
              } else {
                return <></>
              }
            }
            return (
              <div className="hover:bg-[#F6F6F6] w-full h-[46px]  flex items-center justify-center">
                <button
                  onClick={() => {
                    moveToPageByPath(el.path)
                  }}
                  className="w-full h-full"
                >
                  {(el as any).translationKey
                    ? t((el as any).translationKey)
                    : el.name}
                </button>
              </div>
            )
          })}
        </div>
      </>
    )
  }

  const createButtonEl = () => {
    if (userData?.userInfo && userData?.userInfo) {
      const { name } = userData.userInfo

      return (
        <>
          <div
            className="font-bold md:py-[13px] px-[2px] md:px-[20px] flex items-center gap-2 relative"
            onMouseEnter={() => {
              setLogOutStatus(true)
            }}
          >
            <p className="text-[14px] hover:text-[#768296] ">{`MY (${name})`}</p>
            <img
              src={
                logOutStatus
                  ? 'assets/img/icon_arrow.png'
                  : 'assets/img/icon_arrow2.png'
              }
              alt="arrow"
              className="w-[12.8px] h-[8.25px]"
            />
          </div>
        </>
      )
    } else {
      return (
        <>
          <div className="flex  text-[14px]">
            <button
              className="font-bold py-[13px] px-[17px] md:px-[34px]  hover:text-[#768296]"
              onClick={() => {
                moveToPageByPath('sign-in')
              }}
            >
              {t('header.login')}
            </button>
            <FreeButton
              className="bg-href  text-white font-bold  py-[6px] md:py-[13px] px-[17px] md:px-[34px] rounded-[30px] md:rounded-[60px]"
              onClick={() => {
                moveToPageByPath('sign-up')
              }}
            >
              {t('header.signup')}
            </FreeButton>
          </div>
        </>
      )
    }
  }

  useEffect(() => {
    if (refetch && typeof refetch === 'function') {
      setRefetch(refetch)
    } else {
      logger.info('Refetch not ready:', refetch)
    }

    if (planRefetch && typeof planRefetch === 'function') {
      setPlanRefetch(planRefetch)
    } else {
      logger.info('planRefetch not ready:', planRefetch)
    }
  }, [refetch, setRefetch, planRefetch, setPlanRefetch])

  useEffect(() => {
    if (hambugerStatus) {
      // scroll 금지'
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [hambugerStatus])
  useEffect(() => {
    if (
      pathname !== '/sign-in' &&
      pathname !== '/sign-up' &&
      pathname !== '/terms'
    ) {
      prevSet({ prevUrl: pathname })
    }

    if (userData?.userInfo && !userData?.userInfo.termsAccepted) {
      const userType = urlParams.get('userType')
      navigate(`/terms?userType=${userType}`)
    }
  }, [pathname])

  // useEffect 내부에서 사용
  useEffect(() => {
    const node = document.getElementById('fastcut-extension-installed')

    if (node?.dataset.installed === 'true') {
      logger.info('✅ Fastcut 확장 프로그램 설치 감지 (DOM)')
      saveLocalStorage('fs_extension', true)
    } else {
      logger.info('✅ Fastcut 확장 프로그램 설치 감지 (DOM) 실패')
      saveLocalStorage('fs_extension', false)
    }

    const handler = (event: any) => {
      logger.info('✅ Fastcut 익스텐션 설치 이벤트 감지!', event.detail)
      saveLocalStorage('fs_extension', true)
    }

    window.addEventListener('FASTCUT_EXTENSION_INSTALLED', handler)

    return () => {
      window.removeEventListener('FASTCUT_EXTENSION_INSTALLED', handler)
    }
  }, [pathname])

  return (
    <div
      className={classNames('border-b border-[#D9DEE8] border-gray w-[100%] ', {
        'mb-[30px]':
          pathname !== '/my-page' && pathname !== '/challenge' && !isMobile,
        'mb-6':
          pathname !== '/my-page' && pathname !== '/challenge' && isMobile,
        'mb-[24px]': pathname === '/my-page',
        'mb-0': pathname === '/challenge',
      })}
    >
      <header
        className="flex items-center justify-between max-w-[1400px] h-[80px] md:h-[100px] px-3 md:px-4 my-0 mx-auto relative"
        onMouseLeave={() => setLogOutStatus(false)}
      >
        {logOutStatus && createSelectBtn()}
        {hambugerStatus && (
          <div className="fixed bg-[#FFFFFF] border-t w-full h-[100vh] left-0 top-0 z-[999] overflow-y-auto pb-[200px]">
            {createMobileBtn()}
          </div>
        )}

        <div className="flex items-center  ">
          <button className="mr-8">
            <h1
              onClick={() => {
                navigate('/')
              }}
            >
              <img
                className="w-[100px] md:w-[150px] y-[27px]"
                src="/assets/img/logo/fastcut_kr.png"
                alt="logo"
              />
            </h1>
          </button>
          {!isMobile && (
            <div className="flex text-[14px] z-50">
              {GNB.map((el, index) => {
                if (el.path === 'short-video-editor') {
                  return (
                    <p
                      className={`flex items-center  md:py-[13px] px-[5px]  md:px-[24px]  relative`}
                      onMouseOver={() => {
                        setIsOpen(true)
                      }}
                      onMouseLeave={() => {
                        setIsOpen(false)
                      }}
                      key={index}
                    >
                      <span className="font-bold">
                        {(el as any).translationKey
                          ? t((el as any).translationKey)
                          : el.name}
                      </span>
                      <span>
                        <img
                          src="assets/img/icon_arrow2.png"
                          alt="arrow"
                          className={`w-[12.8px] h-[8.25px] ml-2  transition-transform duration-500  ${
                            !isOpen ? '' : 'rotate-180'
                          }`}
                        />
                      </span>
                      {isOpen && (
                        <div className=" absolute w-[241px] top-10 bg-white border-[1px] border-[#D9DEE8] rounded-[6px] z-50">
                          <button
                            className={`flex  items-center  py-3 px-3  hover:bg-[#F6F6F6] cursor-pointer w-full h-full`}
                            onClick={() => {
                              navigate('/short-video-editor?createType=link')
                              setIsOpen((prev) => !prev)
                            }}
                          >
                            {t('header.navigation.linkCreate')}
                          </button>
                          <button
                            className={`flex  items-center  py-3 px-3  hover:bg-[#F6F6F6] cursor-pointer w-full h-full `}
                            onClick={() => {
                              navigate('/short-video-editor?createType=text')
                              setIsOpen((prev) => !prev)
                            }}
                          >
                            <span>
                              {t(
                                'header.navigation.textCreateWithMultiLanguage'
                              )}
                            </span>
                          </button>
                        </div>
                      )}
                    </p>
                  )
                } else if (el.path === 'price-guide') {
                  return (
                    <p
                      className={`flex items-center  md:py-[13px] px-[5px]  md:px-[24px] relative`}
                      onMouseOver={() => {
                        setPiceGuideOpen(true)
                      }}
                      onMouseLeave={() => {
                        setPiceGuideOpen(false)
                      }}
                      key={index}
                    >
                      <span className="font-bold">
                        {(el as any).translationKey
                          ? t((el as any).translationKey)
                          : el.name}
                      </span>
                      <span>
                        <img
                          src="assets/img/icon_arrow2.png"
                          alt="arrow"
                          className={`w-[12.8px] h-[8.25px] ml-2  transition-transform duration-500  ${
                            !isPriceGuideOpen ? '' : 'rotate-180'
                          }`}
                        />
                      </span>
                      {isPriceGuideOpen && (
                        <div className=" absolute w-[140px] top-10 bg-white border-[1px] border-[#D9DEE8] rounded-[6px]">
                          <button
                            className={`flex  items-center  py-3 px-3  hover:bg-[#F6F6F6] cursor-pointer w-full h-full`}
                            onClick={() => {
                              setPiceGuideOpen((prev) => !prev)
                              moveToPageByPath('price-guide')
                            }}
                          >
                            <span>
                              {t('header.navigation.productVideoPricing')}
                            </span>
                          </button>
                          <button
                            className={`flex  items-center  py-3 px-3 hover:bg-[#F6F6F6] cursor-pointer w-full h-full`}
                            onClick={() => {
                              setPiceGuideOpen((prev) => !prev)
                              moveToPageByPath('shortform-price-guide')
                            }}
                          >
                            {t('header.navigation.contentVideoPricing')}
                          </button>
                        </div>
                      )}
                    </p>
                  )
                } else if (el.path === 'my-videos') {
                  return (
                    userData && (
                      <>
                        {' '}
                        <button
                          className={`flex  items-center font-bold md:py-[13px] px-[5px]  md:px-[24px]  hover:text-[#768296] cursor-pointer ${
                            pathname === `/${el.path}` && 'text-main'
                          }`}
                          onClick={() => {
                            moveToPageByPath(el.path)
                          }}
                          key={index}
                        >
                          {(el as any).translationKey
                            ? t((el as any).translationKey)
                            : el.name}
                          {el.event && el.name === '챌린지' && (
                            <p className="bg-[#FF8800] text-white p-1 font-bold text-[10px] rounded-[4px] ml-1 h-[20px] flex items-center">
                              <span>{t('header.navigation.payback')}</span>
                            </p>
                          )}{' '}
                        </button>
                      </>
                    )
                  )
                } else {
                  return (
                    <button
                      className={`flex  items-center font-bold md:py-[13px] px-[5px]  md:px-[24px]  hover:text-[#768296] cursor-pointer ${
                        pathname === `/${el.path}` && 'text-main'
                      }`}
                      onClick={() => {
                        moveToPageByPath(el.path)
                      }}
                      key={index}
                    >
                      {(el as any).translationKey
                        ? t((el as any).translationKey)
                        : el.name}
                      {el.event && el.name === '챌린지' && (
                        <p className="bg-[#FF8800] text-white p-1 font-bold text-[10px] rounded-[4px] ml-1 h-[20px] flex items-center">
                          <span>{t('header.navigation.payback')}</span>
                        </p>
                      )}{' '}
                    </button>
                  )
                }
              })}
            </div>
          )}
        </div>
        {isMobile ? (
          <>
            <button onClick={handleHambugerIconClick}>
              <img
                src="/assets/img/Icon_hambuger.png"
                alt="hambuger"
                width={32}
              />
            </button>
          </>
        ) : (
          <div className="flex items-center gap-4">
            <LanguageSelector variant="compact" />
            {createButtonEl()}
          </div>
        )}
      </header>
    </div>
  )
}

export default Header
